export default __webpack_public_path__ + "static/media/error.fc389494.svg";